export default "__VITE_ASSET__7ee11acc__"